import Vue from 'vue';
import SourceService from '@/services/source';

import { FETCH_ALL, SEARCH, SAVE } from '../actions.types';
import {
  SET_ERROR,
  SET_ITEMS,
  SET_FILTERS,
  REMOVE_ITEM
} from '../mutations.types';

export default {
  namespaced: true,
  state: {
    items: [],
    pagination: {},
    filters: {
      page: 1
    }
  },
  actions: {
    async [SAVE]({ commit }, data) {
      try {
        await SourceService.correct(data);
        commit(REMOVE_ITEM, data.wrong);
      } catch (error) {
        commit(SET_ERROR, error.data);
      }
    },
    async [FETCH_ALL]({ commit, state }) {
      try {
        const response = await SourceService.query(state.filters);
        commit(SET_ITEMS, response.data);
      } catch (error) {
        commit(SET_ERROR, error.data);
      }
    },
    async [SEARCH]({ commit }, keyword) {
      try {
        const response = await SourceService.search(keyword);
        commit(SET_ITEMS, response.data);
      } catch (error) {
        commit(SET_ERROR, error.data);
      }
    }
  },
  mutations: {
    [SET_ERROR](state, error) {
      state.error = error;
    },
    [SET_ITEMS](state, response) {
      state.error = null;
      state.items = response.data;
      Vue.set(state, 'pagination', response.meta);
    },
    [SET_FILTERS](state, filters) {
      Vue.set(state.filters, filters.key, filters.value);
    },
    [REMOVE_ITEM](state, name) {
      state.error = null;
      const index = state.items.findIndex(item => item.name == name);
      state.items.splice(index, 1);
    }
  }
};
